// deviceInfo.ts
export interface DeviceInfo {
    deviceId: string;
    name: string;
    os: string;
    type: "browser";
}
  
const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
};

const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
};
  
  const generateDeviceId = (): string => {
    // Generate a pseudo UUID
    return "xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  
  export const getDeviceInfo = (): DeviceInfo => {
    // Check for an existing device ID
    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      // Check for a cookie
      deviceId = getCookie("deviceId") || "";
      localStorage.setItem("deviceId", deviceId);
    }
    if (!deviceId) {
      deviceId = generateDeviceId();
      localStorage.setItem("deviceId", deviceId);
      // Set a cookie with the device ID
      setCookie("deviceId", deviceId, 180); // Expires in 1 year
    }
  
    // Use navigator.userAgent to detect OS:
    const ua = navigator.userAgent;
    let os = "Unknown OS";
    if (ua.indexOf("Win") !== -1) os = "Windows";
    else if (ua.indexOf("Mac") !== -1) os = "MacOS";
    else if (ua.indexOf("X11") !== -1) os = "UNIX";
    else if (ua.indexOf("Linux") !== -1) os = "Linux";
  
    // Simple browser detection based on userAgent:
    let name = "Unknown Browser";
    if (ua.indexOf("Chrome") !== -1 && ua.indexOf("Edg") === -1)
      name = "Chrome";
    else if (ua.indexOf("Firefox") !== -1) name = "Firefox";
    else if (ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1)
      name = "Safari";
    else if (ua.indexOf("Edg") !== -1) name = "Edge";
  
    return {
      deviceId,
      name,
      os,
      type: "browser",
    };
  };

//intialize deviceId
getDeviceInfo();